/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { CleanIconButton } from '@neo4j-ndl/react';
import { Prompt } from '@neo4j-ndl/react/ai';
import { PlusIconOutline } from '@neo4j-ndl/react/icons';
import { useState } from 'react';

const Component = () => {
  const [prompt, setPrompt] = useState('');
  const [isRunningPrompt, setIsRunningPrompt] = useState(false);

  const handleSubmitPrompt = () => {
    setIsRunningPrompt(true);
    alert(`You submitted the following prompt: ${prompt}`);
    setPrompt('');
  };

  return (
    <Prompt
      isRunningPrompt={isRunningPrompt}
      value={prompt}
      onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
        setPrompt(event.target.value)
      }
      onSubmitPrompt={handleSubmitPrompt}
      onCancelPrompt={() => setIsRunningPrompt(false)}
      topContent={
        <>
          <Prompt.ContextTag
            onClose={() => {
              alert('remove node label context');
            }}
          >
            Node label
          </Prompt.ContextTag>
          <Prompt.ContextTag
            onClose={() => {
              alert('remove cypher query context');
            }}
          >
            Cypher query
          </Prompt.ContextTag>
          <Prompt.ContextTag
            onClose={() => {
              alert('remove long context');
            }}
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </Prompt.ContextTag>
        </>
      }
      bottomContent={
        <CleanIconButton description="Add files" size="small">
          <PlusIconOutline />
        </CleanIconButton>
      }
    />
  );
};

export default Component;
